import React from "react";

export default function Loader({
  type = "spinner",
  message = "Loading...",
  rows = 5,
  columns = 4,
  className = "",
}) {
  // ============================================
  // SPINNER
  // ============================================
  if (type === "spinner") {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <div className="animate-spin rounded-full h-5 w-5 border-2 border-gray-200 border-t-blue-600" />

        {message && (
          <span className="ml-2 text-sm text-gray-500">
            {message}
          </span>
        )}
      </div>
    );
  }

  // ============================================
  // SECTION / MOVING LINES
  // ============================================
  if (type === "section") {
    return (
      <div
        className={`w-full space-y-4 p-4 animate-pulse ${className}`}
      >
        <div className="h-5 w-1/4 bg-slate-200 rounded" />

        <div className="h-4 w-full bg-slate-200 rounded" />

        <div className="h-4 w-5/6 bg-slate-200 rounded" />

        <div className="h-4 w-4/6 bg-slate-200 rounded" />
      </div>
    );
  }

  // ============================================
  // TABLE
  // ============================================
  if (type === "table") {
    return (
      <div className={`w-full overflow-hidden ${className}`}>
        {/* Header */}
        <div
          className="grid gap-4 px-4 py-3 bg-slate-50 border-b border-slate-200"
          style={{
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
          }}
        >
          {Array.from({ length: columns }).map((_, index) => (
            <div
              key={index}
              className="h-4 bg-slate-200 rounded animate-pulse"
            />
          ))}
        </div>

        {/* Rows */}
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div
            key={rowIndex}
            className="grid gap-4 px-4 py-4 border-b border-slate-100"
            style={{
              gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            }}
          >
            {Array.from({ length: columns }).map((_, columnIndex) => (
              <div
                key={columnIndex}
                className={`h-4 bg-slate-100 rounded animate-pulse ${
                  columnIndex === 0 ? "w-3/4" : "w-full"
                }`}
              />
            ))}
          </div>
        ))}
      </div>
    );
  }

  // ============================================
  // CARD
  // ============================================
  if (type === "card") {
    return (
      <div
        className={`p-5 rounded-xl border border-slate-200 bg-white ${className}`}
      >
        <div className="animate-pulse space-y-4">
          <div className="h-4 w-1/3 bg-slate-200 rounded" />

          <div className="h-8 w-2/3 bg-slate-200 rounded" />

          <div className="h-3 w-1/2 bg-slate-100 rounded" />
        </div>
      </div>
    );
  }

  // ============================================
  // PAGE
  // ============================================
  if (type === "page") {
    return (
      <div className="flex flex-col items-center justify-center h-screen w-screen bg-gray-50 font-sans">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-blue-600 mb-4" />

        <p className="text-gray-600 text-sm font-medium tracking-wide">
          {message}
        </p>
      </div>
    );
  }

  return null;
}